<template>
    <v-hover v-slot:default="{ hover }">
        <v-card
            class="tour-card mx-auto pa-0"
            :class="{ 'active': hover }"
            :href="tour.url"
            target="_blank"
            elevation="4"
            rounded="xl"
        >
            <v-img
                eager
                :src="getImageUrl(tour.image)"
                :alt="tour.title"
                class="tour-image"
            ></v-img>

            <v-card-title class="tour-title">{{ tour.title }}</v-card-title>

            <v-card-text class="text-left">
                <p class="tour-text" v-html="tour.content"></p>
            </v-card-text>
        </v-card>
    </v-hover>
</template>

<script>
import { getMediaPathUrl } from '@/utils/helpers';

export default {
    name: "TourCard",

    props: {
        tour: {
            type: Object,
            required: true,
        },
    },

    methods: {
        getImageUrl(image) {
            try {
                return getMediaPathUrl(image);
            } catch (thrown) {
                return '';
            }
        },
    },
}
</script>

<style scoped>
/** Tour Card styles */
.tour-card {
    transition: 0.3s all ease-in-out;
    background-color: #fff;
    height: 100%;
}

.tour-card.active {
    background-color: #2d76e3;
}

.tour-card .tour-image>>>.v-image__image {
    transition: 0.3s all ease-in-out;
}

.tour-card.active .tour-image>>>.v-image__image {
    transform: scale(1.1);
}

.tour-card .tour-title {
    color: #000;
    font-size: 26px;
    font-weight: bold;
}

.tour-card.active .tour-title {
    color: #fff;
}

.tour-card .tour-text {
    font-size: 16px;
    padding-bottom: 30px;
}

.tour-card.active .tour-text {
    color: #fff;
}

.tour-card .tour-text>>>a {
    text-decoration: underline !important;
}

.tour-card.active .tour-text>>>a {
    color: #cfd8dc;
}
</style>
